import { render, staticRenderFns } from "./ResourcePage.vue?vue&type=template&id=355b3de0&scoped=true&"
import script from "./ResourcePage.vue?vue&type=script&lang=js&"
export * from "./ResourcePage.vue?vue&type=script&lang=js&"
import style0 from "./ResourcePage.vue?vue&type=style&index=0&id=355b3de0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355b3de0",
  null
  
)

export default component.exports